import { FormHelperText } from "@mui/material";

interface Props {
  remaining: number;
}

export function QuotesOnlyPostingsLeftHelperText(props: Props) {
  const { remaining } = props;

  // Defensive clamp: never show a negative count, whatever the API reports.
  const remainingToShow = Math.max(remaining, 0);
  const noun = remainingToShow === 1 ? "posting" : "postings";
  let text = `Your company has ${remainingToShow} public quotes only ${noun} left this billing month.`;
  if (remainingToShow === 0) {
    text += " Try posting this privately.";
  }

  return <FormHelperText>{text}</FormHelperText>;
}
